export default "__VITE_ASSET__de14759f__"